module.exports = __webpack_public_path__ + "img/logo.cf9933c3.png";